import { getPublishedPosts } from "./posts";

export function searchPosts(query: string) {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return [];

  return getPublishedPosts().filter((post) => {
    const haystack = [
      post.title,
      post.excerpt,
      post.category,
      post.tags.join(" "),
      post.authorProfile.name,
      post.authorProfile.role
    ]
      .join(" ")
      .toLowerCase();

    return haystack.includes(normalizedQuery);
  });
}
